import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ElevatedButton } from '@producer/ui-kit';

import { Space } from '../../../app/entities';

import styles from './workspace-list.module.scss';
import { api } from '../../../api';

interface WorkspaceListProps {
  onAcceptInvitation: () => void;
}

export const WorkspaceList: React.FC<WorkspaceListProps> = observer(({ onAcceptInvitation }) => {
  const spaces = Space.getAll();

  const [isLoading, setIsLoading] = useState(false);

  const handleAcceptInvitation = (invitationId: string) => {
    if (isLoading) return;
    setIsLoading(true);

    api
      .post(`/invitations/${invitationId}/accept`)
      .then(({ data }) => {
        setIsLoading(false);

        const space = spaces.find((el) => el.invitationId === invitationId);
        space.status = 'active';

        if (onAcceptInvitation) {
          onAcceptInvitation(data);
        }
      })
      .catch(() => {
        // TODO display toast
        setIsLoading(false);
      });
  };

  return (
    <div className={styles['list']}>
      {spaces.map((space) => (
        <div className={styles['item']}>
          <div className="column">
            <p>{space.name}</p>
            <p className="caption capitalize">{space.role}</p>
          </div>

          {space.status === 'pending' && (
            <ElevatedButton
              text="Accept invitation"
              isLoading={isLoading}
              onClick={() => handleAcceptInvitation(space.invitationId)}
            />
          )}
        </div>
      ))}
    </div>
  );
});
